import axios from 'axios';

export const flipmeConnectAsync = async ({
  emailCode,
  twoFACode
}: {
  emailCode: string;
  twoFACode: string;
}) => {
  const { data } = await axios.post(`/flipme/connect/confirm`, {
    emailCode,
    twoFACode
  });

  return data;
};

export const flipmeGetInfoAsync = async () => {
  const { data } = await axios.get(`flipme/status`);

  return data;
};

export const flipmeNFTWithdrawAsync = async ({
  userPackageId
}: {
  userPackageId: number;
}) => {
  const { data } = await axios.post(`/flipme/nft-withdraw`, {
    userPackageId
  });

  return data;
};
